<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("package_forms") }}</h5>
      <button
        v-if="active == 1"
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <div v-if="active != 1" class="mb-2">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-if="active < 4"> <a href="" @click.prevent="previous">Back</a></el-breadcrumb-item>
          <el-breadcrumb-item v-if="active == 2">Edit</el-breadcrumb-item>
          <el-breadcrumb-item v-if="active == 3">View</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form v-if="active === 1">
        <app-table :id="tableId" :options="options" @action="getListAction" />
      </el-form>
      <el-form v-if="active === 2">
        <div class="row">
          <div class="col-sm-12">
            <dynamic-form :id="formID" :formRevisionId="form_revision_id" :backList="previous" :type="formType"></dynamic-form>
          </div>
        </div>
      </el-form>
      <el-form v-if="active === 3">
        <div class="row">
          <div class="col-sm-12">
            <form-preview :back="previous" :id="form_body_id" :formRevisionId="form_revision_id"></form-preview>
          </div>
        </div>
      </el-form>
    </template>

    <template slot="footer" v-if="active == 1">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      <!-- <button
        type="button"
        class="btn btn-primary mr-2"
        data-dismiss="modal"
        @click="submit"
      >
        {{ $t("update") }}
      </button> -->
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import * as actions from "../../../../Config/ApiUrl";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper.js";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";

export default {
  name: "FormList",
  extends: CoreLibrary,
  mixins: [FormMixin, ModalMixin, TableHelpers],
  props: {
    id: Number,
  },
  data() {
    return {
      removedata: {},
      form_revision_id: 0,
      formID: 0,
      form_body_id: 0,
      formType: '',
      active: 1,
      modalId: "package-forms-view-Modal",
      packages: {},
      isFormModalActive: false,
      selectedUrl: "",
      tableId: "advance-table",
      options: {
        name: "AdvanceTable",
        url: actions.PACKAGE_FORMS_LIST + "/" + this.id,
        showHeader: true,
        columns: [
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "get_forms",
            modifier: (value,row) => {
              return `<a href="#" id="${row.id + '_' + row.form_body_id + '_' + row.form_id}"  @click=${this.myFunction(row)}>${this.$t(value.name ?? "---")}</a>`;
            },
          },
          {
            title: this.$t("business_category"),
            type: "custom-html",
            key: "get_forms",
            modifier: (value) => {
              return `<span>${this.$t(value.form_category != null  ? value.form_category.title : "---")}</span>`;
            },
          },
          {
            title: this.$t("created_by"),
            type: "custom-html",
            key: "form_body_status",
            modifier: (value) => {
              
              let now = new Date();
              var date = moment(value.created_at ?? now).format("YYYY-MM-DD");
              return `<span> ${this.$t(value != null  ? value.created_by != null ? value.created_by.full_name : '---' : '---')}  </span> <br> <span> ${this.$t(date)}  </span>`;
            },
          },
          {
            title: this.$t("updated_by"),
            type: "custom-html",
            key: "form_body_status",
            modifier: (value) => {
              let now = new Date();
              var date = moment(value.updated_at ?? now).format("YYYY-MM-DD");
              
              return `<span> ${this.$t(value!= null ? value.updated_by != null ? value.updated_by.full_name : '---' : '---')}  </span> <br> <span> ${this.$t(date)}  </span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
          },
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
          },
        ],
        // filters: [
        //   {
        //       "title": this.$t('date'),
        //       "type": "range-picker",
        //       "key": "date",
        //       "option": ["today", "thisMonth", "last7Days", "nextYear"]
        //   },
        //   {
        //       "title": this.$t('age'),
        //       "type": "range-filter",
        //       "key": "age-range",
        //       "maxTitle": this.$t('max_age'),
        //       "minTitle": this.$t('min_age'),
        //       "sign": ""
        //   },
        //   {
        //       "title": this.$t('status'),
        //       "type": "checkbox",
        //       "key": "status",
        //       "option": [
        //           {id: 'active', value: 'Active'},
        //           {id: 'inactive', value: 'Inactive'},
        //           {id: 'invited', value: 'Invited'},
        //       ],
        //   },
        //   {
        //       "title": this.$t('gender'),
        //       "type": "radio",
        //       "key": "filter-with-gender",
        //       "option": [
        //           {id: 'male', value: 'Male'},
        //           {id: 'female', value: 'Female'},
        //           {id: 'other', value: 'Other'},
        //       ],
        //       "header": {
        //           "title": this.$t('want_to_filter_your_list'),
        //           "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
        //       },
        //   },
        //   {
        //       "title": this.$t('search_and_select'),
        //       "type": "drop-down-filter",
        //       "key": "search select",
        //       "option": [],
        //   }
        // ],
        showFilter: false,
        showSearch: false,
        showCount: true,
        showClearFilter: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "View") {
        this.view(rowData.id,rowData.form_body_id);
        // this.openDeleteModal();
      } else if (actionObj.title == "Edit") {
        this.edit(rowData.id,rowData.form_id);
      } else if (actionObj.title == "Delete") {
        this.deleteForm(rowData.id);
      }
    },
    edit(id,form_id) {
      this.form_revision_id = id;
      this.formID = form_id;
      this.formType = 'questionnaire';
      if (this.active++ > 3) this.active = 1;
    },

   myFunction(data){
        let doc = document.getElementById(data.id + '_' + data.form_body_id + '_' + data.form_id);  
        if(doc){
            doc.addEventListener('click', () => {
            this.view(data.id, data.form_body_id)
            }) 
        }
        },
    view(id,form_body_id) {
      this.form_body_id = form_body_id;
      this.form_revision_id = id;
      this.active = 3;
    },
    previous() {
      this.active = 1;
    },

    deleteForm(form_revision_id) {
      this.removedata.package_id = this.id;
      this.removedata.form_revision_id = form_revision_id; 
      let url = `${actions.PACKAGE_FORM_DELETE}`;
      if (confirm("Are you sure you want to delete!")) { 
            axiosPost(url,this.removedata)
              .then((response) => {
                this.$toastr.s(response.data.message);
              })
              .catch(({ error }) => {
                //trigger after error
              })
              .finally(() => {
                this.$hub.$emit("reload-" + this.tableId);
            });
      }
      
    },
  },
};
</script>